// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wh_a bhr_b","TwoDimsListFeature__item":"wh_b bhr_we","TwoDimsListFeature__item__text":"wh_c bhr_vt"};